// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';
import FontAwesome from 'react-fontawesome';
import pluralize from 'pluralize';
import { css } from 'glamor';
import { Col, Row } from 'react-bootstrap';

import type { Platform as PlatformType } from '~/types';

const platformRule = css({
    padding: '25px',
    backgroundColor: '#f9f9f9',
    height: '100%',
    width: '100%',
});

const imageRule = css({
    height: '150px',
    width: '150px',

    '@media(max-width: 768px)': {
        height: '100px',
        width: '100px',
    },
});

const titleRule = css({
    fontSize: '1.2em',
    fontWeight: 900,
    color: 'rgb(228, 65, 34)',
});

const paragraphRule = css({
    minHeight: '80px',
    height: '80px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '@media(max-width: 768px)': {
        minHeight: 0,
        height: '40px',
        display: 'none',
    },
});

const linkRule = css({
    '&:hover': {
        textDecoration: 'none',
    },
});

const japaneseRule = css({
    marginLeft: '5px',
});

const reviewsRule = css({
    position: 'relative',
});

const iconRule = css({
    color: '#000',
    position: 'absoulte',
    top: '2px',
});

const labelRule = css({
    position: 'absolute',
    left: '20px',
    color: 'rgb(228, 65, 34)',
});

const blockRule = css({
    marginLeft: '15px',
});

@observer
export default class Platform extends React.Component {
    props: {
        platform: PlatformType,
    };

    render() {
        const { platform } = this.props;
        const reviewsCount = platform.reviews.filter(
            r => r.state === 'published'
        ).length;

        return (
            <div { ...platformRule }>
                <Row>
                    <Col xs={ 4 }>
                        <Link { ...linkRule } to={ `/platforms/${platform.slug}` }>
                            <img
                                src={ platform.image && platform.image.secure_url }
                                alt={ platform.name }
                                title={ platform.name }
                                className="pull-left"
                                { ...imageRule }
                            />
                        </Link>
                    </Col>

                    <Col xs={ 8 }>
                        <div { ...blockRule }>
                            <Link
                                { ...linkRule }
                                to={ `/platforms/${platform.slug}` }
                            >
                                <h4 { ...titleRule }>
                                    {platform.name}
                                    <span { ...japaneseRule }>
                                        {platform.japanese}
                                    </span>
                                </h4>
                            </Link>
                            <p { ...paragraphRule }>
                                {platform.content.brief.md}
                            </p>
                            <div { ...reviewsRule }>
                                <Link
                                    { ...linkRule }
                                    to={ `/platforms/${platform.slug}` }
                                >
                                    <FontAwesome name="gamepad" { ...iconRule } />
                                    <span { ...labelRule }>
                                        {reviewsCount ?
                                            `${reviewsCount} ${pluralize('review', reviewsCount)}` :
                                            'No review yet'}
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/platform/Platform/index.js